import { leftSideHooks } from 'shared/hooks'

const leftSide: leftSideHooks.LeftSideInput = {
	bottomList: [],
	type: 'upgrade'
}

export function useLeftMenu() {
	leftSideHooks.useLeft(leftSide)
}
